/**
 * @file  ModalFluid/index.tsx
 * @description full page modal
 *
 *
 * @author ogarcia (ozkary)
 *
 */
import React from 'react';
import './styles.scss';
import * as S from './styles';

/**
 * @description layout styled element
 *
 * @param Props
 */
const ModalFluid = ({ onCancel, visible, children }: S.Props): JSX.Element => (
  <S.Modal className="modal-fluid" onCancel={onCancel} open={visible}>
    {children}
  </S.Modal>
);

export default ModalFluid;
